// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style__wrapper__7ZxU-","body":"style__body__McFw3"};